import styled from 'styled-components';
import { PlainIconButton } from '../../../../lib/components/fuse-buttons/src/buttons';
import { GridItem, GridRow, gridConfig } from '../../fuse-responsive-grid/src/grid';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';
import variantConfig from './config';

const StyledAlert = styled(GridRow).attrs({
	className: 'fuse-alert',
})`
	border-radius: var(--brand-border-radius, 6px);
	${(props) => `
		background: ${variantConfig[props.variant].background};

		${
	props.banner
		? `grid-template-columns: repeat(11,1fr) 32px;`
		: `grid-template-columns: repeat(12,1fr);`
}
		
	`}

	padding: var(--spacing-global-space4) var(--spacing-global-space5);

	${(props) =>
		props.size === 'responsive' &&
		`
		@media screen and (min-width: ${gridConfig.m.minWidth}) {
			padding: var(--spacing-global-space4) var(--spacing-global-space5);
		}

		@media screen and (min-width: ${gridConfig.l.minWidth}) {
			padding: var(--spacing-global-space5) var(--spacing-global-space6);
		}
	`}
`;

const StyledAlertHeading = styled(TypographyComponent).attrs({
	className: 'fuse-alert__heading',
	'data-testid': 'fuse-alert__heading',
	type: 'heading',
	size: { xxs: 'm1', m: '1', l: '2' },
})`
	margin-bottom: var(--spacing-global-space2);

	&:last-child {
		margin: 0;
	}
`;
const StyledAlertMessage = styled(TypographyComponent).attrs({
	className: 'fuse-alert__message',
	'data-testid': 'fuse-alert__message',
	type: 'paragraph',
	size: 'm1',
})`
	color: var(--color-global-black);
	margin: 0 0 var(--spacing-global-space3);

	&:last-child {
		margin: 0;
	}
`;

const StyledAlertContentContainer = styled(GridItem).attrs({
	className: 'fuse-alert__content-container',
	'data-testid': 'fuse-alert__content-container',
})`
	${({ showIcon, size, variant }) => `
		display:grid;
		grid-template-columns: ${showIcon ? 'var(--spacing-global-space7) auto' : 'auto'};
		grid-column-gap: var(--spacing-global-space3);

		${
	showIcon
		? `
			&::before {
				display: grid;
				content: '';
				mask: url('data:image/svg+xml,${encodeURIComponent(variantConfig[variant].icon)}') top left/contain
					no-repeat;
				-webkit-mask: url('data:image/svg+xml,${encodeURIComponent(
		variantConfig[variant].icon,
	)}') top left/contain
					no-repeat;
				background: ${variantConfig[variant].iconColour};
			}
		`
		: ``
}
		
		${
	size === 'responsive' &&
			`
			@media screen and (min-width: ${gridConfig.l.minWidth}) {
				grid-column-gap: var(--spacing-global-space5);
			}
		`
}
	`}
`;

const StyledAlertContent = styled.div.attrs({
	className: 'fuse-alert__content',
	'data-testid': 'fuse-alert__content',
})`
	display: flex;
	flex-direction: column;
	min-height: var(--spacing-global-space7);
	justify-content: center;
`;

const StyledCloseButtonContainer = styled.div.attrs({
	className: 'fuse-alert__close-button-container',
	'data-testid': 'fuse-alert__close-button-container',
})`
	display: grid;
	height: fit-content;
	justify-content: flex-end;

	@media screen and (min-width: ${gridConfig.l.minWidth}) {
		grid-column-start: 12;
	}
`;

const StyledIconButton = styled(PlainIconButton).attrs({
	className: 'fuse-alert__close-button',
	'data-testid': 'fuse-alert__close-button',
})``;

export {
	StyledAlert,
	StyledAlertContent,
	StyledAlertContentContainer,
	StyledAlertHeading,
	StyledAlertMessage,
	StyledCloseButtonContainer,
	StyledIconButton,
};
